import { loadStripe, type Stripe } from "@stripe/stripe-js";

// Publishable key is NOT a secret — it is safe to ship in the client bundle.
// Test-mode key; swap for the live pk_live_… key when going live.
const PUBLISHABLE_KEY =
  "pk_test_51TnWUCCC1rf1Nru15mfiajbhezswWC3gIjLJICGof61NmxIuO2O8AoFZesrUXBlrIIghxUMXqZroTN8ogh5oVayF00LJvQnyQn";

// Single shared promise — loadStripe injects js.stripe.com once and caches.
let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) stripePromise = loadStripe(PUBLISHABLE_KEY);
  return stripePromise;
}
